<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    title="添加"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="800px"
  >
    <div class="dialog-body">
      <!-- 表格 -->
      <EdmCustomTable
        ref="customTable"
        checkbox
        :loading="tableLoading"
        :table-data="tableData"
        :show-empty="isShowEmpty"
        :front-pagination="true"
        :pagination="pagination"
        row-key="columnName"
        :reserve-selection="true"
        :default-checked-keys="defaultCheckedKeys"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column
          v-for="(cm, index) in tableColumns"
          :key="cm.field"
          :label="cm.name"
          :index="index"
          :width="cm.width"
          :fixed="cm.fixed"
        >
          <template slot-scope="scope">
            <cell-tooltip :text="scope.row[cm.field]" :width="cm.width" />
          </template>
        </el-table-column>
      </EdmCustomTable>
      <!-- /表格 -->
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CellTooltip from "@/components/private/cell-tooltip";
import reportConfigApi from "@/api/report-config/index";
export default {
  name: "FastTableAdd",
  components: {
    CellTooltip
  },
  inject: ["sqldata"],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      searchForm: {
        value: ""
      },
      tableLoading: false,
      tableColumns: [
        {
          name: "表格列key",
          field: "columnName",
          width: "300",
          fixed: false
        },
        {
          name: "表格列名称",
          field: "columnTitle",
          width: "auto",
          fixed: false
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      isShowEmpty: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableData = [];
      const parmasData = this.sqldata();
      reportConfigApi.testSql({ originalSql: parmasData.originalSql, datasourceId: parmasData.datasourceId }).then(res => {
        if (res.data && res.data.length > 0) {
          const keys = Object.keys(res.data[0]) || [];
          this.tableData = keys.map(item => ({
            columnName: item,
            columnTitle: item
          }));
          this.pagination.total = Number(keys.length);
        }
      });
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    handleConfirm() {
      // 获取选中的数据
      const checkedArr = this.$refs.customTable.getChecked();
      this.$emit("confirm", checkedArr);
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang='scss'>
.dialog-body{
  margin-top: 16px;
}
</style>
